// src/helpers/schedule/config.js
export const HOURS_PER_DAY = 8;
export const DEFAULT_TOLERANCE = 10;       // % if project.Tolerance missing
export const DEFAULT_EXCHANGE_RATE = 1;    // if project.ExchangeRate?.Rate missing

export const num = (v, d = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : d;
};
export const sum = (arr = []) => arr.reduce((s, v) => s + num(v), 0);

export const getExchangeRate = (project) =>
  num(project?.ExchangeRate?.Rate ?? project?.exchangeRate ?? project?.CurrencyRate, DEFAULT_EXCHANGE_RATE);

export const getTolerance = (project) =>
  num(project?.Tolerance, DEFAULT_TOLERANCE);

// Progress is 0..1, risk tapers down with progress.
// You can swap this with EV-based logic later.
export const riskPctAtProgress = (baseTolerancePct, progress01) => {
  const p = Math.max(0, Math.min(1, progress01));
  return Math.max(0, baseTolerancePct * (1 - p));
};

// min/max bands like your C# “GMP ± TOLERANCE%”
export const minCostWithTol = (cost, tolPct) => cost - (cost * tolPct) / 100;
export const maxCostWithTol = (cost, tolPct) => cost + (cost * tolPct) / 100;
